import {ActiveConstants, TransferConstants} from "finhelper";

export const getActionType = (active) => {

    if([...ActiveConstants.INCOME_GROUP, ...[ActiveConstants.CUSTOM_INCOME]].includes(active.type_id))
    {
        return TransferConstants.INCOME;
    }else if([...ActiveConstants.SPENDING_GROUP, ...[ActiveConstants.CUSTOM_SPEND]].includes(active.type_id)){
        return TransferConstants.SPENDING;
    }
}